<template>
  <!--«««Всплывающая галерея изображений-->
  <div v-if="loading_is_complete" class="product-popup-gallery-color-overlayer close-popup-slider"></div>
  <div v-if="loading_is_complete"
       :class="[imagesLenght == 1 ? 'single-mode' : '']"
       class="product-popup-gallery">
    <div class="product-popup-gallery__wrapper">
      <div class="popup-gallery">
        <button @click="closePopup"
                class="button-v2 button-v2_transparent-3 button-v2_small  close-popup-slider">
          <div class="button-v2__inner">
            <div class="button-v2__icon-box">
              <svg preserveAspectRatio="none" viewBox="0 0 24 24" height="24px" width="24px" fill="none"
                   class="button-v2__icon" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.1 19.778A1.5 1.5 0 1 0 4.223 21.9L12 14.12l7.778 7.778a1.5 1.5 0 1 0 2.122-2.12L14.12 12 21.9 4.222A1.5 1.5 0 1 0 19.78 2.1L12 9.88 4.222 2.1A1.5 1.5 0 1 0 2.1 4.22L9.879 12 2.1 19.778z"/>
              </svg>
            </div>
          </div>
        </button>

        <swiper
            @swiper="setPopupMainSwiper"
            :thumbs="{ swiper: thumbsSwiper }"
            :navigation="{
              prevEl: '#pts-arr-prev',
              nextEl: '#pts-arr-next',
            }"
            class="popup-gallery__main-swiper-container">
          <swiper-slide v-for="image in images" :key="image.id"
                        class="popup-gallery__main-swiper-slide">
            <img :src='`${img_url}${image.path}`' alt=""
                 class="popup-gallery__main-swiper-photo">
          </swiper-slide>
        </swiper>

        <swiper
            @swiper="setPopupThumbsSwiper"
            :navigation="{
              prevEl: '#pts-arr-prev',
              nextEl: '#pts-arr-next',
            }"
            :centerInsufficientSlides="true"
            :slides-per-view="4"
            :space-between="8"
            :watchSlidesVisibility="true"
            :breakpoints="thumbsOptions.breakpoints"
            class="popup-gallery__thumbs-swiper-container">
          <swiper-slide v-for="image in images" :key="image.id"
                        class="popup-gallery__thumbs-swiper-slide">
            <img :src='`${img_url}${image.path}`' alt=""
                 class="popup-gallery__thumbs-swiper-photo">
          </swiper-slide>
        </swiper>

        <button class="swiper-dir-control-button popup-gallery__arrow pts-arr-prev" id="pts-arr-prev">
          <svg class="swiper-dir-control-button__icon prev" preserveAspectRatio="none" width="14" height="32"
               viewBox="0 0 14 32" xmlns="http://www.w3.org/2000/svg">
            <path d="m14 31h-9l-5-15 5-15h9l-5 15zm-7.6-2h4.8l-4.3-13 4.3-13h-4.8l-4.3 13z">
            </path>
          </svg>
        </button>

        <button class="swiper-dir-control-button popup-gallery__arrow pts-arr-next" id="pts-arr-next">
          <svg class="swiper-dir-control-button__icon next" preserveAspectRatio="none" width="14" height="32"
               viewBox="0 0 14 32" xmlns="http://www.w3.org/2000/svg">
            <path d="m9 31h-9l5-15-5-15h9l5 15zm-6.2-2h4.8l4.3-13-4.3-13h-4.8l4.3 13z"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <!--Всплывающая галерея изображений»»»-->
</template>

<script>
// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

// import Swiper core and required modules
import SwiperCore, {
  Navigation, Thumbs
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default {
  name: "ProductPopupGallery",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      thumbsSwiper: null,
      thumbsOptions: {
        breakpoints: {
          1024: {
            slidesPerView: 9,
          },
          760: {
            slidesPerView: 6,
          }
        }
      },
    };
  },
  mounted() {
    this.ppJs.swipers.product_card_popup_main = null
    this.ppJs.swipers.product_card_popup_thumbs = null
  },
  computed: {
    images() {
      return this.$store.getters['product/GET_IMAGES']
    },
    imagesLenght() {
      return this.$store.getters['product/GET_IMAGES_LENGTH']
    },
    loading_is_complete() {
      return this.$store.getters['product/GET_LOADING_IS_COMPLETE']
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    closePopup(event) {
      let windowWidth = window.innerWidth;
      if (windowWidth > 760) {
        let galleryBg = document.querySelector('.product-popup-gallery-color-overlayer');
        let popupGallery = document.querySelector('.product-popup-gallery');
        galleryBg.style.display = 'none';
        popupGallery.style.display = 'none';
        this.ppJs.general.main.style.zIndex = '';
        document.body.style.overflow = '';
      }
    },
    setPopupThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper
      this.ppJs.swipers.product_card_popup_thumbs = swiper
      swiper.$wrapperEl.addClass("popup-gallery__thumbs-swiper-wrapper")
    },
    setPopupMainSwiper(swiper) {
      this.ppJs.swipers.product_card_popup_main = swiper

      swiper.$wrapperEl.addClass("popup-gallery__main-swiper-wrapper")
    },
  },
}
</script>

<style scoped>

</style>